import React, { useState } from 'react'
// Ant Design
import { Flex, Typography, Image, message, Avatar } from 'antd'
// Ant Design Icons
import { FolderOutlined, PlusCircleOutlined, CaretDownOutlined, CaretUpOutlined, LoginOutlined, UserOutlined, AppstoreOutlined } from '@ant-design/icons'
// React Icons
import { MdGTranslate } from "react-icons/md";
// React Router
import { useNavigate, Link, useLocation } from 'react-router-dom'
// Assets
import Logo from '../Assets/logoStadistics.png'
// i18
import { useTranslation } from 'react-i18next'
// Axios
import axios from 'axios'
// Config
import config from '../config'
import { getConfig } from '../config'

export const Sidebar = () => {

    const { Title, Text } = Typography
    const navigate = useNavigate()
    const location = useLocation()
    const [messageApi, contextHolder] = message.useMessage()
    const { t, i18n } = useTranslation(["translation"])
    
    const [language, setLanguage] = useState(false)

    const changeLenguague = (len) => {
        if(len==="es") {
            i18n.changeLanguage("es")
            localStorage.setItem("lang", "true")
        }
        else {
            i18n.changeLanguage("en")
            localStorage.setItem("lang", "false")
        }
    };

    const onLogout = async() => {
        try {
            const res = await axios.post(config.urlApi + "/logout")
            if(res.status === 200) {
                localStorage.removeItem("admin")
                navigate("/")
            }
        }
        catch(error) {
            if (error.status === 401) {
                navigate("/")
            }
            else {
                messageApi.error(t("error_logout"))
            }
        }
    }

    return (
        <Flex vertical style={{ position: "relative", width: "250px", height: "100vh", backgroundColor: "#000", padding: "0 15px" }}>
            <Flex vertical align="center" style={{ padding: "10px 0", borderBottom: "1px solid #fff" }}>
                <Image width={100} src={getConfig("logo")==="" ? Logo : getConfig("logo")} alt="Logo" />
                <Title level={4} style={{ color: "#fff", marginBottom: "5px" }}>{getConfig("titulo")}</Title>
            </Flex>

            <Flex vertical style={{ width: "100%", height: "calc(100vh - 170px)", overflowY: "auto" }}>
                <Link to="/new" className={location.pathname === "/new" && "active"} style={{ fontSize: "20px", padding: "10px", borderRadius: "5px", marginTop: "15px", cursor: "pointer" }}>
                    <PlusCircleOutlined style={{ color: "#fff", marginRight: "10px" }} />
                    <Text style={{ fontSize: "16px", color: "#fff" }}>{t("new_report")}</Text>
                </Link>

                <Link to="/list" className={location.pathname === "/list" && "active"} style={{ padding: "10px", borderRadius: "5px", marginTop: "15px", cursor: "pointer" }}>
                    <FolderOutlined style={{ fontSize: "20px", color: "#fff", marginRight: "10px" }} />
                    <Text style={{ fontSize: "16px", color: "#fff" }}>{t("report")}</Text>
                </Link>

                <Link to="/views" className={location.pathname === "/views" && "active"} style={{ fontSize: "20px", padding: "10px", borderRadius: "5px", marginTop: "15px", cursor: "pointer" }}>
                    <AppstoreOutlined style={{ color: "#fff", marginRight: "10px" }} />
                    <Text style={{ fontSize: "16px", color: "#fff" }}>{t("views")}</Text>
                </Link>

                {localStorage.getItem("admin")==="true" &&
                    <Link to="/users" className={location.pathname === "/users" && "active"} style={{ fontSize: "20px", padding: "10px", borderRadius: "5px", marginTop: "15px", cursor: "pointer" }}>
                        <UserOutlined style={{ color: "#fff", marginRight: "10px" }} />
                        <Text style={{ fontSize: "16px", color: "#fff" }}>{t("users")}</Text>
                    </Link>
                }

                <Flex onClick={() => setLanguage(!language)} className={language && "active"} align="center" justify="space-between" style={{ fontSize: "20px", padding: "10px", borderRadius: "5px", marginTop: "15px", cursor: "pointer" }}>
                    <Flex>
                        <MdGTranslate style={{ color: "#fff", marginRight: "10px" }} />
                        <Text style={{ fontSize: "16px", color: "#fff" }}>{t("language")}</Text>
                    </Flex>

                    {!language ? <CaretDownOutlined style={{ fontSize: "16px", color: "#fff" }} /> : <CaretUpOutlined style={{ fontSize: "16px", color: "#fff" }} />}
                </Flex>

                {language && 
                    <>
                        <Flex onClick={() => changeLenguague("es")} justify="center" style={{ padding: "5px", borderRadius: "5px", marginTop: "5px", cursor: "pointer" }}>
                            <Text style={{ fontSize: "16px", color: "#fff" }}>{t("spanish")}</Text>
                        </Flex>
                        <Flex onClick={() => changeLenguague("en")} justify="center" style={{ padding: "5px", borderRadius: "5px", marginTop: "5px", cursor: "pointer" }}>
                            <Text style={{ fontSize: "16px", color: "#fff" }}>{t("english")}</Text>
                        </Flex>
                    </>
                }

                <Flex onClick={onLogout} align="center" style={{ fontSize: "20px", padding: "10px", borderRadius: "5px", marginTop: "15px", cursor: "pointer" }}>
                    <LoginOutlined style={{ color: "#fff", marginRight: "10px" }} />
                    <Text style={{ fontSize: "16px", color: "#fff" }}>{t("logout")}</Text>
                </Flex>
            </Flex>

            <Flex style={{ position: "absolute", width: "100%", bottom: "0", left: "0", padding: "10px" }}>
                <Flex align="center" style={{ width: "100%", height: "45px", borderRadius: "50px", backgroundColor: "#fff" }}>
                    <Flex align="center">
                        <Avatar style={{ backgroundColor: "#87d068", margin: "0 7px 0 10px" }} icon={<UserOutlined />} />
                        <Text style={{ fontSize: "14px", color: "#000" }}>{localStorage.getItem("user")}</Text>
                    </Flex>
                </Flex>
            </Flex>

            {contextHolder}
        </Flex>
    )
}
